module.exports = __webpack_public_path__ + "static/media/right-arrow-long.f2bbfb62.svg";